import moment from 'moment';

export const formatNumber = (num) => {
  num = (+num || 0)
  return Math.round(num * 1000) / 1000;
}

// currently unused with new data structure. Kept for posterity
export const calculateEarnedPto = (today, startDate) => {
  const ptoTable = [10, 10, 10, 14, 14, 15, 15, 15, 15, 15, // from 0 year to 9 years
    16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]; // from 10 years to 24 years

  var dayOneThisYear = moment(today).startOf('year');
  var todayMoment = moment(today);
  var startDateMoment = moment(startDate);
  var workDays = todayMoment.diff(startDateMoment, 'days') + 1;
  var workYears = todayMoment.diff(startDateMoment, 'years');
  var daysPassedThisYear = moment(today).diff(dayOneThisYear, 'days') + 1;

  var workDaysThisYear = 0;

  if (workDays < daysPassedThisYear) {
    workDaysThisYear = workDays;
  } else {
    workDaysThisYear = daysPassedThisYear;
  }

  // if you works more than one year
  if (workYears > 0) {
    var workAnniversary = moment(startDate).add(workYears, 'years');
    if (workAnniversary.isBefore(dayOneThisYear)) {
      workAnniversary = moment(startDate).add(workYears + 1, 'years');
    }
    var workDaysThisYearAfter = todayMoment.diff(workAnniversary, 'days') + 1;
    var workDaysThisYearBefore = workAnniversary.diff(dayOneThisYear, 'days');
    var ptoRateBeforeAnniversary = ptoTable[workYears - 1] ? ptoTable[workYears - 1] : ptoTable[ptoTable.length - 1];
    var ptoRateAfterAnniversary = ptoTable[workYears] ? ptoTable[workYears] : ptoTable[ptoTable.length - 1];

    // if today is before anniversary
    if (workDaysThisYearBefore > daysPassedThisYear) {
      ptoRateBeforeAnniversary = ptoTable[workYears] ? ptoTable[workYears] : ptoTable[ptoTable.length - 1];
      ptoRateAfterAnniversary = ptoTable[workYears + 1] ? ptoTable[workYears + 1] : ptoTable[ptoTable.length - 1];
      workDaysThisYearBefore = daysPassedThisYear;
      workDaysThisYearAfter = 0;
    }

    // console.log(` ${workDaysThisYearBefore} x ${ptoRateBeforeAnniversary} + ${workDaysThisYearAfter} x ${ptoRateAfterAnniversary}`);
    return {
      earnedPto: `${Math.round((workDaysThisYearBefore * ptoRateBeforeAnniversary + workDaysThisYearAfter * ptoRateAfterAnniversary) / 365 * 1000) / 1000}`,
      workDaysThisYear: `${workDaysThisYear}`,
      ptoRateAfterAnniversary: `${ptoRateAfterAnniversary}`,
      workDaysThisYearAfter: `${workDaysThisYearAfter}`,
      workDaysThisYearBefore: `${workDaysThisYearBefore}`
    };
  } else {
    return {
      earnedPto: `${Math.round(workDaysThisYear * ptoTable[0] / 365 * 1000) / 1000}`,
      ptoRateAfterAnniversary: 10,
      workDaysThisYear: `${workDaysThisYear}`
    };
  }
}

export const calculateTimeoffDuration = (startDate, endDate, hours) => {
  let totalDiffDays = moment(endDate).diff(moment(startDate), 'days');
  let diffDaysNextYear = 0;

  if (totalDiffDays === 0) {
    totalDiffDays = (hours || 8) / 8
  } else {
    totalDiffDays += 1;

    let diffDays = 0;

    // Don't calculate saturdays and sundays
    for (var i = 0; i < totalDiffDays; i++) {
      const theDay = moment(startDate).add(i, 'day');
      const dayOfWeek = theDay.weekday()
      if (dayOfWeek > 0 && dayOfWeek < 6) {
        diffDays += 1;
        if (theDay.year() !== moment(startDate).year()) {
          ++diffDaysNextYear;
        }
      }
    }

    totalDiffDays = diffDays;
  }

  return {
    totalDiffDays: totalDiffDays,
    diffDaysNextYear: diffDaysNextYear
  };
}

export const isSequentialDate = (dateA, dateB) => {

  let totalDiffDays = moment(dateB).diff(moment(dateA), 'days');
  let startDate = (totalDiffDays >= 0) ? dateA : dateB;

  totalDiffDays = Math.abs(totalDiffDays);

  if (totalDiffDays < 4) {
    let diffDays = 0;
    // Don't calculate saturdays and sundays
    for (var i = 0; i < totalDiffDays; i++) {
      const dayOfWeek = moment(startDate).add(i, 'day').weekday()
      if (dayOfWeek > 0 && dayOfWeek < 6) {
        diffDays += 1;
      }
    }
    if (diffDays <= 1) {
      return true;
    }
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js